
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-copy)"}},[_c('path',{attrs:{"d":"M11.429 3.357H1.714C.768 3.357 0 4.125 0 5.071v9.715c0 .947.768 1.714 1.714 1.714h9.715c.946 0 1.714-.768 1.714-1.714V5.07c0-.946-.768-1.714-1.714-1.714zM12 14.786a.571.571 0 01-.571.571H1.714a.571.571 0 01-.571-.571V5.07c0-.315.256-.571.571-.571h9.715c.315 0 .571.256.571.571v9.715z"}}),_c('path',{attrs:{"d":"M14.285.5H4c-.946 0-1.714.768-1.714 1.714a.571.571 0 101.143 0c0-.315.256-.571.571-.571h10.286c.316 0 .572.256.572.571V12.5a.571.571 0 01-.572.571.571.571 0 000 1.143c.947 0 1.714-.767 1.714-1.714V2.214C16 1.268 15.232.5 14.285.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-copy"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    